import Cookies from 'js-cookie'
import { 
  UserKey, 
  TokenKey,
  CustomerServiceKey,
  LayoutCollpaseKey,
  LicenceKey,
  TermsKey
} from './keys'
import local from './local'
import { jsonParse } from '../index'
const expires = 1.5
//登录相关
export const SaveLoginData = ({ token, userInfo, customer_service2 }) => {
  //token
  Cookies.set(TokenKey, token, { expires })
  //用户信息
  SetUser(userInfo)
  //客服信息
  local.setItem(CustomerServiceKey, customer_service2)
}
export const removeLoginData = () => {
  Cookies.remove(TokenKey)
  Cookies.remove(UserKey)
  local.removeItem(CustomerServiceKey)
}
export const GetToken = () => Cookies.get(TokenKey) || ''
export const GetUser = () => {
  let userInfo = jsonParse(Cookies.get(UserKey))
  return typeof userInfo == 'object'
    ? userInfo
    : {}
}
export const SetUser = userInfo =>
  Cookies.set(UserKey, JSON.stringify(userInfo), { expires })
export const GetCustomerService = () => 
  local.getItem(CustomerServiceKey) || ''
//确认协议
export const Licence = {
  get: () => {
    let data = Cookies.get(LicenceKey) || '2'
    return parseInt(data) == 1 ? 1 : 2
  },
  set: (data, expires = 15) => {
    data == 1
    ? Cookies.set(LicenceKey, '1', { expires })
    : Cookies.remove(LicenceKey)
  }
}
//条款
export const Terms = {
  get: () => {
    let data = Cookies.get(TermsKey) || '2'
    return parseInt(data) == 1 ? 1 : 2
  },
  set: (
    data, 
    expires = 15  //默认15天
  ) => {
    data == 1
    ? Cookies.set(TermsKey, '1', { expires })
    : Cookies.remove(TermsKey)
  }
}


// WEBPACK FOOTER //
// ./src/utils/cookies/index.js